
document.querySelectorAll('.accordion-toggle').forEach(button => {
    button.addEventListener('click', () => {
      // Close all accordion contents
    
      // Open the clicked accordion content
      const content = button.nextElementSibling;
      const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';


      if (!isOpen) {

        document.querySelectorAll('.accordion--content').forEach(content => {
            // content.style.display = "none";
            content.style.maxHeight = 0;

        });
    
        // Remove 'active' class from all buttons
        document.querySelectorAll('accordion-item').forEach(btn => {
            btn.classList.remove('active');
        });
  
          
        content.style.maxHeight = content.scrollHeight + "px";
        button.closest('accordion-item').classList.toggle('active');
      } else {
        content.style.maxHeight = 0;
        button.closest('accordion-item').classList.toggle('active');
      }
    });
});